//  ----------      START   IMPORT  BLOCK       ----------
import { useNavigate } from 'react-router-dom';
//  Widgets
import { Navbar, Nav, Container } from 'react-bootstrap';
//  Icons
import logo from '../../../../../Assets/Images/cleir_logo.png';
import { AiFillHome } from 'react-icons/ai';
//  Config
import VocabLandingPage from '../../../../../ConfigFiles/multilingual/VocabLandingPage';
import { FRONTEND_ROUTES } from '../../../../../ConfigFiles/Routes/frontend_routes';
import './LandingTopBar.css';
import { LanguageSelector } from '../../../Generic/LanguageSelector';
//  ----------      END   IMPORT  BLOCK       ----------


function LandingTopBar({ lan }) {
  const navigate = useNavigate();

  return (
    <Navbar expand="lg" bg="light" variant="light" className="w-100">
      <Container>
        <img
          src={logo}
          width="40"
          height="40"
          className="d-inline-block align-top logo-img"
          alt="App logo"
        />
        <Navbar.Brand onClick={() => navigate(FRONTEND_ROUTES.landing)} style={{ cursor: 'pointer' }}>
          MedCleir
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="landing-navbar-nav" />
        <Navbar.Collapse id="landing-navbar-nav" className="justify-content-end">
          <Nav>

            <Nav.Link onClick={() => navigate(FRONTEND_ROUTES.landing)} title="Home" className="align-nav-icon">
              <AiFillHome size={20} />
            </Nav.Link>
            <Nav.Link onClick={() => navigate(FRONTEND_ROUTES.static_professionals)}>
              {VocabLandingPage.profiessionals[lan]}
            </Nav.Link>
            <Nav.Link onClick={() => navigate(FRONTEND_ROUTES.static_patients)}>
              {VocabLandingPage.patients[lan]}
            </Nav.Link>
            <Nav.Link onClick={() => navigate(FRONTEND_ROUTES.auth)}>
              {VocabLandingPage.jump_in[lan]}
            </Nav.Link>
            <Nav.Link onClick={() => navigate(FRONTEND_ROUTES.static_about)}>
              {VocabLandingPage.about[lan]}
            </Nav.Link>
            <Nav.Item><LanguageSelector/></Nav.Item>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default LandingTopBar;
